module.exports = __webpack_public_path__ + "static/img/workerlogin.2edd94a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workerlogin.jpeg
// module id = Zx1U
// module chunks = 62